export const SDK_VERSION = '6.3.0';
